import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";

const VarietyList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getcropVariety } = useHttp();

  const [cropVariety, setCropVarietyData] = useState([]);

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: `/api/varieties/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`
      },
      (res) => {
        if (res) {
          // //console.log("setCropVarietyData", res);
          setData(res);
          setAllData(res);
          // //console.log(cropdata);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail();
  }, [getcropVariety]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, varietyId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Variety detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/varieties/?orgId=${localStorage.getItem(
              "orgId"
            )}&createdBy=${parseInt(
              localStorage.getItem("id")
            )}&varietyId=${varietyId}&serviceId=${serviceId}`,
            method: "DELETE",
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getCropVarietyDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.varietyName.toLowerCase().includes(filetrtext) ||
        item.cropTypeName.toLowerCase().includes(filetrtext) ||
        item.varietyNo.toLowerCase().includes(filetrtext) ||
        // item.cropDuration.includes(filetrtext) ||
        item.cropName.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "100%",
      width: "700px", // Adjust the width as needed
     // height: "80%",
      minHeight: "300px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    console.log(data);

    setSelectedData(data);

    setIsModalOpen(true);
  };
   const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);


  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2" style={{ border: "1px soild black" }}>
          <div className="col-4">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Variety Detail{" "}
            </label>{" "}
          </div>
          <div className="col-6"> </div>
          <div className="col-2">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
                props.sId(serviceId || 0);
              }}
            >
              Add Variety
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered table-responsive text-center">
                        <thead>
                          <tr>
                            <td></td>
                            <th>Crop Type </th>
                            <th>Crop Name </th>
                            <th>Crop No </th>
                            <th>Crop Variety </th>
                            <th>Variety No </th>

                            <th> Avg days to harvest </th>
                            <th> Crop Duration </th>

                            <th>Status</th>
                            <th>View</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <img
                                  src={`${process.env.REACT_APP_FILE_URL}${x.cropProfileUrl}`}
                                  className="user-image img-circle"
                                  width="60"
                                  height="60"
                                  alt="crop image"
                                />
                                <td>{x.cropTypeName}</td>

                                <td>{x.cropName}</td>

                                <td>{x.cropName}</td>

                                <td>{x.varietyName}</td>

                                <td>{x.varietyNo}</td>

                                <td>{x.AvgDaysToHarvest}</td>

                                <td>{x.cropDuration}</td>
                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                {/* <td>
                                  <button className="btn">
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td> */}
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) =>
                                      handleDelete(e, x.varietyId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
           {/* view modal */}
           <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Variety Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Crop Type: {selectedData.cropTypeName}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
               Crop Name: {selectedData.cropName}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
               Crop Variety Name: {selectedData.varietyName}
              </p>
              <p className="col-md-6">
                Crop Variety No : {selectedData.varietyNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Avg Days To Harvest: {selectedData.AvgDaysToHarvest}
              </p>
              <p className="col-md-6">Crop Duration(days): {selectedData.cropDuration}</p>
            </div>
            <div className="row">
              <p className="col-md-6">Unit Of Area: {selectedData.cproductionAreaUnit}</p>
              <p className="col-md-6">
              Production Quantity: {selectedData.unitProduction}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Production Unit: {selectedData.productionUnit}</p>
             
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default VarietyList;
